module.exports = __webpack_public_path__ + "static/img/carousel1.9e59d428.png";